import { StyleTransferExperience } from './StyleTransferExperience';

export function GuestTransferPage() {
  return <StyleTransferExperience variant="guest" />;
}
